import { css as e } from "@microsoft/fast-element";
import { normalize as r } from "../common/normalize.js";
import { display as l, PropertyStyleSheetBehavior as d } from "@matrix42/fast-foundation";
import { typography as n } from "../styles/typography.js";
import { designTokens as t } from "../design-tokens.js";
function i(o, a) {
  return new d("chartLegendPosition", o, a);
}
const p = e`
  .legend-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: 100%;
    flex: 1;
  }

  .chart-content {
    flex-direction: column;
  }

  .legend-item {
    padding-right: ${t.spacing["1.5"]};
    padding-left: ${t.spacing["1.5"]};
  }
`, s = e`
  .legend-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: 100%;
    padding: ${t.spacing[1]};
  }

  .legend-item {
    padding-right: ${t.spacing["1.5"]};
    padding-left: ${t.spacing["1.5"]};
  }

  .chart-content {
    flex-direction: column-reverse;
  }
`, g = e`
  .chart-content {
    flex-direction: row;
  }

  .legend-item:first-of-type {
    padding-top: 0;
  }

  .legend-item:last-of-type {
    padding-bottom: 0;
  }

  .legend-list {
    min-width: fit-content;
  }
`, c = e`
  .chart-content {
    flex-direction: row-reverse;
  }

  .legend-item:first-of-type {
    padding-top: 0;
  }

  .legend-item:last-of-type {
    padding-bottom: 0;
  }
`, w = e`
  ${r}
  ${l("flex")}

  :host {
    display: flex;
    height: 100%;
    width: 100%;
  }

  .control {
    /* Typography */
    display: flex;
    padding: ${t.spacing[1]};
    flex: 1;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
  }
  .legend-item:focus-visible {
    outline: ${t.borderWidth.xs} solid
      ${t.color.primary[100]};
    padding-left: ${t.spacing[1]};
  }

  .legend-list:focus-visible {
    outline: ${t.borderWidth.xs} solid
      ${t.color.primary[100]};
  }

  .chart-container {
    container: chart-container / inline-size;
    display: flex;
    flex-direction: column;
    gap: ${t.spacing[6]};
    padding: ${t.spacing[3]} ${t.spacing[2]}
      ${t.spacing[3]} ${t.spacing[2]};
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
  }

  .chart-canvas-wrapper {
    display: flex;
    padding: ${t.spacing[1]};
    max-height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    min-height: 0;
  }

  .chart-canvas-inner-wrapper {
    max-height: 100%;
    min-height: 100%;
    min-width: 100%;
    max-width: 100%;
    gap: ${t.spacing[6]};
    padding: ${t.spacing[2]};
  }

  .chart-canvas {
    height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
  }

  .chart-content {
    gap: ${t.spacing[6]};
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .legend-list {
    min-height: ${t.spacing[24]};
    max-height: ${t.spacing[48]};
    max-width: fit-content;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    padding: ${t.spacing[3]};
    margin: ${t.spacing[1]};
  }

  .legend-list-border {
    border: ${t.spacing["0.5"]} solid
      ${t.color.neutral[50]};
    border-radius: ${t.borderRadius.xs};
  }

  .legend-item {
    display: flex;
    gap: ${t.spacing[1]};
    color: ${t.color.neutral[200]};
    align-items: center;
    user-select: none;
    padding: ${t.spacing[1]} ${t.spacing[2]};
  }

  .legend-item {
    ${n("label", "regular")}
  }

  .legend-item.highlight {
    ${n("label", "semibold")}
  }

  .legend-item.non-highlight {
    opacity: 0.4;
  }

  .legend-dot {
    height: ${t.spacing[2]};
    width: ${t.spacing[2]};
    border-radius: ${t.borderRadius.full};
  }

  .legend-label {
    max-width: ${t.spacing[24]};
    word-wrap: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .accessibility-content {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    white-space: nowrap;
    clip: rect(1px, 1px, 1px, 1px);
    margin-top: -3px;
    opacity: 0.01;
  }

  .tooltip {
    position: absolute;
    background-color: ${t.color.neutral[30]};
    color: ${t.color.neutral[500]};
    padding-left: ${t.spacing[4]};
    padding-right: ${t.spacing[4]};
    padding-top: ${t.spacing[2]};
    padding-bottom: ${t.spacing[2]};
    border-radius: ${t.borderRadius.xs};
    pointer-events: none;
    transition: opacity 0.2s ease;
    opacity: 0;
    box-shadow: ${t.shadow.box.xs};
  }

  .tooltip::after {
    content: '';
    position: absolute;
    bottom: -${t.spacing[4]};
    left: 50%;
    width: 0;
    height: 0;
    transform: translateX(-50%);

    border: ${t.spacing[4]} solid transparent;
    border-bottom: 0;
    border-top: ${t.spacing[4]} solid
      ${t.color.neutral[30]};
  }

  .tooltip-title {
    font-weight: ${t.fontWeight.semibold};
    margin: 0;
  }

  .tooltip-label {
    font-weight: ${t.fontWeight.regular};
    margin: 0;
  }
`.withBehaviors(
  i("top", p),
  i("bottom", s),
  i("left", g),
  i("right", c)
);
export {
  w as pieChartStyles
};
